import React from 'react';
import { Box, Container } from '@mui/material';
import ModalAlert from '~/components/modals/ModalAlert/ModalAlert';
import SuccessModal from '~/components/modals/SuccessModal/SuccessModal.tsx';
import { appFormStyles } from '~/modules/guarantees/legacy/styles.ts';
import type { TGuaranteesModalAlertState, TGuaranteesModalSuccessState } from '../../types.ts';

const noop = () => undefined;

interface IApplicationPageFrameProps {
  children: React.ReactNode;
  modalAlert: TGuaranteesModalAlertState;
  modalSuccess?: TGuaranteesModalSuccessState;
  onModalClose: () => void;
  onSuccessModalClose?: () => void;
}

const ApplicationPageFrame: React.FC<IApplicationPageFrameProps> = ({
  children,
  modalAlert,
  modalSuccess,
  onModalClose,
  onSuccessModalClose = noop,
}) => (
  <Box sx={appFormStyles.pageRoot}>
    <Container maxWidth="xl">
      <Box sx={appFormStyles.paper}>{children}</Box>

      {!!modalAlert.text && (
        <ModalAlert
          isOpen={!!modalAlert.text}
          text={modalAlert.text}
          buttonValue={modalAlert.buttonValue}
          onClick={modalAlert.onClick}
          onClose={onModalClose}
        />
      )}

      {!!modalSuccess?.text && (
        <SuccessModal
          isOpen={!!modalSuccess.text}
          text={modalSuccess.text}
          buttonValue={modalSuccess.buttonValue}
          onClick={modalSuccess.onClick}
          onClose={onSuccessModalClose}
        />
      )}
    </Container>
  </Box>
);

export default ApplicationPageFrame;
